import React from 'react';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <div className="bg-deepblue-900 text-white py-3 md:py-6 border-y-4 border-aqua-500" data-id="element-331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-332">
        <FadeIn data-id="element-333">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 text-center divide-x divide-deepblue-700/50" data-id="element-334">
            <div className="flex flex-col items-center justify-center px-1 md:px-2" data-id="element-335">
              <Users className="w-4 h-4 md:w-6 md:h-6 text-aqua-400 mb-1 md:mb-2" data-id="element-336" />
              <span className="font-display font-bold text-sm md:text-xl" data-id="element-337">
                +300 profes
              </span>
              <span className="text-deepblue-200 text-[10px] md:text-sm" data-id="element-338">
                confían
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-1 md:px-2" data-id="element-339">
              <BookOpen className="w-4 h-4 md:w-6 md:h-6 text-aqua-400 mb-1 md:mb-2" data-id="element-340" />
              <span className="font-display font-bold text-sm md:text-xl" data-id="element-341">
                6 Tomos
              </span>
              <span className="text-deepblue-200 text-[10px] md:text-sm" data-id="element-342">
                + 6 Bonos
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-1 md:px-2" data-id="element-343">
              <div className="flex items-center gap-0.5 md:gap-1 mb-1 md:mb-2" data-id="element-344">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 md:w-5 md:h-5 fill-yellow-400 text-yellow-400" data-id="element-345" />)}
              </div>
              <span className="font-display font-bold text-sm md:text-xl" data-id="element-346">
                4.9/5
              </span>
              <span className="text-deepblue-200 text-[10px] md:text-sm" data-id="element-347">
                valoración
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-1 md:px-2" data-id="element-348">
              <MapPin className="w-4 h-4 md:w-6 md:h-6 text-aqua-400 mb-1 md:mb-2" data-id="element-349" />
              <span className="font-display font-bold text-sm md:text-xl" data-id="element-350">
                🇦🇷 Todo el país
              </span>
              <span className="text-deepblue-200 text-[10px] md:text-sm" data-id="element-351">
                envío digital
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>;
}